import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SignInCompoent } from '../sign-in/sign-in.compoent';
import {
  Icon,
  ModalContainer,
  ModalService,
  PageModalContainer,
  Theme,
  ThemeStore,
} from '@client';

@Component({
  selector: 'app-login-modal',
  imports: [
    CommonModule,
    SignInCompoent,
    ModalContainer,
    PageModalContainer,
    Icon,
  ],
  templateUrl: './login-modal.modal.html',
  styleUrl: './login-modal.modal.scss',
})
export default class LoginModal {
  readonly themeStore = inject(ThemeStore);
  private originalTheme: Theme;
  readonly modalService = inject(ModalService);

  ngOnInit() {
    this.themeStore.setTheme('light');
  }

  constructor() {
    this.originalTheme = this.themeStore.theme() ?? ({} as Theme);
    this.themeStore.setTheme('light');
  }

  close() {
    this.themeStore.setTheme('dark');
    this.modalService.close();
  }
}
